import NiceModal from "@ebay/nice-modal-react";
import { Confirm, Alert } from "./components/common";

//https://github.com/eBay/nice-modal-react#declare-your-modal-instead-of-register
// If use by id, need to register the modal component.
// Normally you create a modals.js file in your project
// and register all modals there.

// 두번 이상 사용되는 모달만 id 지정해놓은 것. 모든 모달이 관리되고 있는 것은 아니다.

NiceModal.register("confirm", Confirm);
NiceModal.register("alert", Alert);
